<template>
  <div class="banner_bottom_agile_info">
    <div class="container">
      <div class="contact-grid-agile-w3s dir-rtl">
        <div class="col-md-4 contact-grid-agile-w3 fl-right">
          <div class="contact-grid-agile-w31">
            <i class="fa fa-phone" aria-hidden="true"></i>
            <h4>نشانی ما</h4>
            <p>
              استان خراسان رضوی، شهرستان تربت جام،محله: شهرک آزادگان، معبر ماقبل آخر: کوچه شهید عباسپور 13 (انصار 10)، معبر آخر: خیابان آزادگان  شهید عباسپور 15، پلاک 0،ساختمان دفتر سفارش آنلاین راداَپ وحید سعیدی راد، طبقه همکف 
              <br />
              کد پستی : 9571744435
            </p>
          </div>
        </div>
        <div class="col-md-3 contact-grid-agile-w3 fl-right">
          <div class="contact-grid-agile-w32">
            <i class="fa fa-envelope-o" aria-hidden="true"></i>
            <h4>تماس با ما</h4>
            <p style="direction: ltr">
              <!-- <a href="tel:05152543659" target="_blank">051-52543659</a>
							<br /> -->
							<a href="tel:05152524850" target="_blank">051-52524850</a>
              <p class=""><a href="tel:09928728971" target="_blank">0992-872-8971</a></p>
							<p class="mt-0"><a href="tel:09903573351" target="_blank">0990-357-3351</a></p>
            </p>
          </div>
        </div>
        <div class="col-md-4 contact-grid-agile-w3 fl-right">
          <div class="contact-grid-agile-w33">
            <i class="fa fa-map-marker" aria-hidden="true"></i>
            <h4>ایمیل</h4>
            <p>
              <a href="mailto:info.radap@gmail.com">info.radap@gmail.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InformationTemplate",
};
</script>

<style scoped>
.fl-right {
  float: right;
}
</style>